import { cva } from '@/styled-system/css';

export const alertRecipe = cva({
  base: {
    display: 'flex',
    paddingBlock: 'Alert.padding.horz',
    paddingInline: 'Alert.padding.horz',
    borderRadius: 'Alert',
    borderWidth: 'Alert',
    borderStyle: 'solid',
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: 'Alert.critical.bg',
        borderColor: 'Alert.critical.border',
      },
      info: {
        backgroundColor: 'Alert.info.bg',
        borderColor: 'Alert.info.border',
      },
      success: {
        backgroundColor: 'Alert.success.bg',
        borderColor: 'Alert.success.border',
      },
      warning: {
        backgroundColor: 'Alert.warning.bg',
        borderColor: 'Alert.warning.border',
      },
    },
  },
});
